import { Component, Input } from '@angular/core';
import { CeoV2Auth } from 'src/app/interfaces/ceo-v2.interface';
import { CeoV2Service } from '../ceo-v2.service';

/**
 * The second factor of every v2 CEO write (plan 16 §1.3): the write password, an audit reason, and — for a release
 * or a rollback — the AM version typed back. The button stays disabled until all of them are there; the server
 * checks them again (`401`/`429` lockout, `400 CONFIRMATION_MISMATCH`).
 */
@Component({
  selector: 'app-ceo-v2-write',
  templateUrl: './ceo-v2-write.component.html',
})
export class CeoV2WriteComponent {
  @Input() label = 'Apply';
  /** When set, the caller must type exactly this before the button enables. */
  @Input() confirmText: string | null = null;
  @Input() danger = false;
  /** Runs the write; resolves to an error message to show, or null on success. */
  @Input() submit!: (auth: CeoV2Auth) => Promise<string | null>;

  reason = '';
  confirm = '';
  busy = false;
  error = '';
  done = false;

  constructor(public v2: CeoV2Service) {}

  get ready(): boolean {
    return !this.busy && !!this.v2.password && this.reason.trim().length >= 3 && (!this.confirmText || this.confirm === this.confirmText);
  }

  async go(): Promise<void> {
    if (!this.ready) return;
    this.busy = true;
    this.error = '';
    this.done = false;
    try {
      const auth: CeoV2Auth = { password: this.v2.password, reason: this.reason.trim(), ...(this.confirmText ? { confirm: this.confirm } : {}) };
      const failure = await this.submit(auth);
      if (failure) {
        this.error = failure;
        // A rejected password must not be replayed on the next write.
        if (/^PASSWORD_(INCORRECT|REQUIRED)\b/.test(failure)) this.v2.password = '';
      } else {
        this.done = true;
        this.reason = '';
        this.confirm = '';
      }
    } finally {
      this.busy = false;
    }
  }
}
